import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Tabs, UIKits } from "../../../Constants/Constants";
import BorderTabs from "./BorderTabs/BorderTabs";
import IconTabs from "./IconTabs/IconTabs";
import JustifyTab from "./JustifyTab/JustifyTab";
import MaterialLeftStyleTab from "./MaterialLeftStyleTab/MaterialLeftStyleTab";
import MaterialStyleTab from "./MaterialStyleTab/MaterialStyleTab";
import PillsTab from "./PillsTab/PillsTab";
import SimpleTab from "./SimpleTab/SimpleTab";
import VerticalTab from "./VerticalTab/VerticalTab";
import { Fragment } from "react/jsx-runtime";
import BackgroundPillTab from "./BackgroundPillTab/BackgroundPillTab";
import ArrowTabs from "./ArrowTabs/ArrowTabs";
import BottomTabs from "./BottomTabs/BottomTabs";
import AnimatedHorizontalTabs from "./AnimatedHorizontalTabs/AnimatedHorizontalTabs";

const TabsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Tabs} parent={UIKits} />
      <Container fluid>
        <Row>
          <SimpleTab />
          <IconTabs />
          <VerticalTab />
          <PillsTab />
          <JustifyTab />
          <MaterialLeftStyleTab />
          <MaterialStyleTab />
          <BorderTabs />
          <BackgroundPillTab />
          <ArrowTabs />
          <BottomTabs />
          <AnimatedHorizontalTabs />
        </Row>
      </Container>
    </Fragment>
  );
};
export default TabsContainer;
